<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<div class="form-row">
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servTypeES')}}
												</label>
												<select v-model="instance.servTypeES" class="form-control" multiple>
													<option v-for="servTypeES in servTypeESList" :value="servTypeES.id" :key="servTypeES.id">
													{{ servTypeES.typeESName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servService')}}
												</label>
												<select v-model="instance.servService" class="form-control" multiple>
													<option v-for="servService in servServiceList" :value="servService.id" :key="servService.id">
														{{ servService.serviceName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servType')}}
												</label>
												<select v-model="instance.servType" class="form-control" multiple>
													<option v-for="servType in servTypeList" :value="servType.id" :key="servType.id">
														{{ servType.typeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.servCategory')}}
												</label>
												<select v-model="instance.servCategory" class="form-control">
													<option v-for="servCategory in servCategoryList" :value="servCategory.id" :key="servCategory.id">
														{{ servCategory.categoryName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.cost')} ) }}</label>
												<input type="number" step="any" v-model="instance.costInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
											
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.cost')})}}</label>
												<input type="number" step="any" v-model="instance.costEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.cost')})}}</label>
												<input type="number" step="any" v-model="instance.costSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {} "/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										
									</div> <!--end form-row-->
									<div class="row">
										<div class="col-md-4" align="left">
										</div>
										<div class="col-md-4" style="text-align:center">
											<b-button class="btn btn-primary btn-sm"
												@click="search()">
												<fa icon="search"/>
													&nbsp; {{ $t('vtabTrans.sSearch') }}
											</b-button>
											&ensp;
											<button class="btn btn-light btn-sm" @click="reset()">
												<fa icon="refresh"/>
												&nbsp; {{ $t('vtabTrans.sReset') }}
											</button>
										</div>
										<div class="col-md-4" align="right">
											<b-button v-if="typeView == 'show'" class="btn btn-primary btn-sm"
												@click="editPrice ">
												<fa icon="refresh"/>
													&nbsp; {{ $t('default.button.editPrice') }}
											</b-button>
											<b-button v-if="typeView == 'edit'" class="btn btn-light btn-sm"
												@click="typeView = 'show' ">
												<fa icon="reply"/>
													&nbsp; {{ $t('default.button.cancel') }}
											</b-button>

										</div>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>

						<div v-show="typeView == 'show'" class="datatable">
							<div 
								v-if="$store.getters.flash.msg
								&& typeResMsg=='success'" :class="'alert alert-'+typeResMsg" role="alert" v-html="$store.getters.flash.msg" />
							<datatable-instance :instanceClassAttr="instanceClassAttr" ref="componentDatatableInstance"/>
						</div>
						<div v-if="typeView == 'edit'" class="table-responsive">
							<div 
								v-if="$store.getters.flash.msg
								&& typeResMsg=='danger'" :class="'alert alert-'+typeResMsg" role="alert" v-html="$store.getters.flash.msg" />
							<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
								<thead class="border-bottom thead-light">
									<tr class="small text-uppercase text-muted">
										<th scope="col" width="10%">
											{{ $t(instanceClassAttr.instanceClass+'.servTypeES')}}
										</th>
										<th scope="col" width="15%">
											{{ $t(instanceClassAttr.instanceClass+'.servService')}}
										</th>
										<th scope="col" width="30%">
											{{ $t(instanceClassAttr.instanceClass+'.servType')}}
										</th>
										<th scope="col" width="30%">
											{{ $t(instanceClassAttr.instanceClass+'.cost')}}
										</th>	

									</tr>
									
								</thead>
								<tbody>
									<!-- NOUVEAU PRIX -->
									<tr v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="border-bottom table-warning">
										<td align="center" colspan="2" >
											<div class="fw-bold text-uppercase align-right" >
												{{ $t(instanceClassAttr.instanceClass+'.newCost')}}
											</div>
										</td>
										<td align="center" colspan="1" >
											<div class="fw-bold align-right">
												<input type="number" step="any" v-model="newPrice" class="form-control" :class="{'is-invalid': v$.newPrice.$error, 'is-valid': (!v$.newPrice.$error && v$.newPrice.$dirty) }" @input="amountToLetter($event, 'amount')" @change="amountLetter = {}; changePrice()"/>
												<span class="small text-muted d-none d-md-block" v-if="v$.newPrice.$error">
													{{ v$.newPrice.$errors[0].$message }}
												</span>
												<span v-if="amountLetter && amountLetter.amount != '' " class="amount-letter">
													{{amountLetter.amount}}
												</span>
											</div>
										</td>
										<td align="center" colspan="1">
											<div class="fw-bold align-right">
												<b-button class="btn btn-success" 
													@click="handleSubmit()" >
													<span >
														<fa icon="check"/>
														{{ $t("default.button.update")}}
													</span>
												</b-button>
											</div>
										</td>
									</tr>
									<tr class="border-bottom" 
										v-for="servTypeStockES in servTypeStockESList" 
										:key="servTypeStockES.id">

										<td>
											<div class="font-weight-bold">
												{{servTypeStockES.servTypeESLib}}
											</div>
										</td>
										<td>
											<div class="font-weight-bold">
												{{servTypeStockES.servServiceLib}}
											</div>
										</td>
										<td>
											<div class="font-weight-bold">
												{{servTypeStockES.servTypeLib}}
											</div>
										</td>
										<td>
											<div class="input-group small text-muted">
												<input type="number" step="any" min="0" v-model="servTypeStockES.cost" class="form-control" disabled/>
											</div>
										</td>

									</tr>
							
								</tbody>
							</table>
						
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>

		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'servTypeStockES',
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servtypestockes.label'),
				pageTitle: this.$t('servtypestockes.list'),
				pageIcon: 'tags',
				instanceClassAttr: {
					instanceClass: 'servtypestockes',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '15%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: false,
						actPrint: 'produce'
					},
					attrsList: [
						// {attrName: 'id', attrCol: '10%', searchable: true, sortable: true, attrRep: ''},
						{attrName: 'servTypeESLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'servServiceLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'servTypeLib', attrCol: '30%', searchable: false, sortable: true},
						{attrName: 'quantity', attrCol: '15%', searchable: false, sortable: true},
						{attrName: 'cost', attrCol: '15%', searchable: false, sortable: false}
					]
				},
				instance: {},
				servTypeESList: [],
				servServiceList: [],
				servCategoryList: [],
				servTypeList: [],
				amountLetter: {},
				chartOptions: {
					title: 'Statistique des prix par ',
					hAxis: {title: 'Article / Produit'},
					vAxis: {title: 'Prix'}
				},
				chartData: [],
				typeStats: [
					{id: 'servType', label: this.$t('servtype.label')},
					{id: 'servService', label: this.$t('servservice.label')},
				],
				typeStat: 'servType',

				vueRules: {
					newPrice: { required }
				},
				servTypeStockESList: [],
				newPrice: '',
				lastPrice: '',
				typeResMsg:'danger',
				typeView: 'show',
					
			}
		},
		validations () {
			return this.vueRules
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST servTypeESList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtypees'
				})
				.then(response => {
					this.servTypeESList = response.data
				})
				.catch(error => {
					console.log('error catch servtypees == ', error.message)
				})
				// GET LIST servServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'servservice'
				})
				.then(response => {
					this.servServiceList = response.data
				})
				.catch(error => {
					console.log('error catch servservice == ', error.message)
				})
				// GET LIST servServiceList
				await this.$store.dispatch('axiosGet', {
					domain: 'servcategory'
				})
				.then(response => {
					this.servCategoryList = response.data
				})
				.catch(error => {
					console.log('error catch servCategoryList == ', error.message)
				})
				// GET LIST servTypeList
				await this.$store.dispatch('axiosGet', {
					domain: 'servtype'
				})
				.then(response => {
					this.servTypeList = response.data
				})
				.catch(error => {
					console.log('error catch servtype == ', error.message)
				})
			}
			this.reset();
		},
		methods: {
			reset(){
				this.instance = {
					servTypeES: [],
					servService: [],
					servType: [],
					servCategory:'',
					quantity: '',

					costSup: '',
					costEq: '',
					costInf: '',
				};
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				strParamsForms = strParamsForms+"&params1=servTypeES.id&valParams1="+this.instance.servTypeES +"&logParams1=inL"
				if(this.instance.servTypeES && this.instance.servTypeES.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeESList, this.instance.servTypeES, 'typeESName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servTypeES')+'(s) : </i><b>'+strLibs + '</b>'
				}

				strParamsForms = strParamsForms+"&params2=servService.id&valParams2="+this.instance.servService +"&logParams2=inL"
				if(this.instance.servService && this.instance.servService.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servServiceList, this.instance.servService, 'serviceName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servService')+'(s) : </i><b>'+strLibs + '</b>'
				}
				strParamsForms = strParamsForms+"&params3=servType.id&valParams3="+this.instance.servType +"&logParams3=inL"
				if(this.instance.servType && this.instance.servType.length >0){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servTypeList, this.instance.servType, 'typeName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servType')+'(s) : </i><b>'+strLibs + '</b>'
				}

				strParamsForms = strParamsForms+"&aliasList=_servType"
				strParamsForms = strParamsForms+"&params7=_servType.servCategory.id&valParams7="+this.instance.servCategory +"&logParams7=eqL"
				if(this.instance.servCategory && this.instance.servCategory != ''){
					let strLibs = this.$refs.componentDatatableInstance.getStrLibs(this.servCategoryList, [this.instance.servCategory], 'categoryName')
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.servCategory')+'(s) : </i><b>'+strLibs + '</b>'
				}

				// Amout super
				strParamsForms = strParamsForms+"&params4=cost&valParams4="+this.instance.costSup+"&logParams4=geDo"
				if(this.instance.costSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' >= </i><b>'+this.$store.getters.formatAmount(this.instance.costSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params5=cost&valParams5="+this.instance.costEq+"&logParams5=eqDo"
				if(this.instance.costEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.costEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params6=cost&valParams6="+this.instance.costInf+"&logParams6=leDo"
				if(this.instance.costInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.cost')+' <;= </i><b> '+this.$store.getters.formatAmount(this.instance.costInf) + '</b>'
				}
				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria('list');
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Type", "Quantité par Type"] 
				let attrKey = 'servTypeLib'
				let attrValue = 'cost'
				if(this.typeStat === 'servType' )
					attrKey = 'servTypeLib'
				else if(this.typeStat === 'servService' ){
					statLabel = ["Service", "Quantité par Service"]
					attrKey = 'servServiceLib'
				}
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				dataList?.forEach(data => {
					this.chartData.push(data);	
				});
			},
			async editPrice(){
				this.typeView = 'edit'
				this.servTypeStockESList = this.$refs.componentDatatableInstance.getAllItems()
				
			},
			changePrice(){
				let strRes = "Confirmez le changement des prix ci-affichés à "+ this.$store.getters.formatAmount(this.newPrice)
				let index = 1;
				this.servTypeStockESList?.forEach(servTypeStock =>{
					strRes = strRes+ " | "+ index?.toString()+ ". "+ servTypeStock?.lib+ " -> "+ this.$store.getters.formatAmount(servTypeStock.cost)
					index += 1
					servTypeStock.cost = this.newPrice
				});
				// strRes = strRes+ "<br> à "+ this.$store.getters.formatAmount(this.newPrice)
				this.lastPrice = strRes
			},
			async handleSubmit() {
				let result = await this.v$.$validate()
				const proceed = window.confirm(this.lastPrice);		
				if (this.newPrice && this.newPrice != '')
					result = true

				if(!result)
					return
				else{
					if(proceed){
						this.$store.dispatch('initFlash');
						this.$store.dispatch('loading')
						this.axiosPost()
					}
					else
						console.log('Pas confirmé')
				}
			},
			async axiosPost() {
				try {
					if(this.servTypeStockESList && this.servTypeStockESList.length > 0){
						await this.$store.dispatch('axiosPost', {
							domain: 'servtypestockes/changeprice',
							data: this.servTypeStockESList
						})
						.then(res => {
							// console.log('res.data == ', res.data)
							if (res.data && res.data.message){
								// const textarea = document.createElement('textarea');
								// textarea.innerHTML = res.data.message;
								// console.log('textarea.value  == ', textarea.value)
								// const parser = new DOMParser();
								// const doc = parser.parseFromString(res.data.message, 'text/html');
								// console.log('doc  == ', doc)
								/*this.$nextTick(() => {
									this.$store.dispatch('showToast', {
										type: 'success', message:res.data.message
									});
									this.$router.push('/servtypestockes')
								});*/
								this.typeResMsg = 'success'
								this.$store.getters.getErrorMsgFormatted(res.data.message);
								this.typeView = 'show'
							}
							else if (res.data && res.data.error){
								this.typeResMsg = 'danger'
								this.$store.getters.getErrorMsgFormatted(res.data.message);
								/*this.$nextTick(() => {
									this.$store.dispatch('showToast', {
										type: 'danger', message:res.data.message
									});
									this.$router.push('/servtypestockes')
									
								});*/
							}
							this.$store.dispatch('unloading')

						})
						.catch(error => {
							this.typeResMsg = 'danger'
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

		}
		
	}

</script>